import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { StateObservable } from 'redux-observable';
import State from '../../core/State';
import { catchError, filter, map, mergeMap } from 'rxjs/internal/operators';
import api from '../../core/api';
import UserAuthenticationSucceed from '../events/UserAuthenticationSucceed';
import { AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import UserDetailsGetSucceed from '../events/UserDetailsGetSucceed';
import Role from '../../../domain/Role';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        filter(
            (event: Event) =>
                event.type === UserAuthenticationSucceed.type && (event as UserAuthenticationSucceed).sessionDetails.role === Role.User
        ),
        mergeMap((event: UserAuthenticationSucceed) => {
            return backend
                .get(`${api()}users/` + event.sessionDetails.customerId, {
                    Authorization: event.sessionDetails.token
                })
                .pipe(
                    map((response: AjaxResponse) => {
                        return new UserDetailsGetSucceed(response.response);
                    })
                );
        }),
        catchError((errorEvent: Event) => of(errorEvent))
    );



// WEBPACK FOOTER //
// ./src/application/user/epic/getUserDetails.ts